export function IconPrinter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : "42"} height={props.height ? props.height : "42"} fill={props.color? props.color : "#000000"} viewBox="0 0 256 256">
      <rect width={props.width ? props.width : "42"} height={props.height ? props.height : "42"} fill="none"></rect>
      <polyline points="64 80 64 40 192 40 192 80" fill="none" stroke={props.color? props.color : "#000000"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></polyline>
      <rect x="64" y="152" width="128" height="68" fill="none" stroke={props.color? props.color : "#000000"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></rect>
      <path d="M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192" fill="none" stroke={props.color? props.color : "#000000"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></path>
      <circle cx="188" cy="116" r="12"></circle>
    </svg>
  )
}
